import { useCallback, useState } from 'react';

/** Error al exportar, clasificado para mostrar un mensaje útil. */
export interface ErrorExportacion {
  /** 'version' = la página quedó desactualizada tras un deploy; 'otro' = cualquier otra falla. */
  tipo: 'version' | 'otro';
  detalle: string;
}

// Mensajes de los navegadores cuando un módulo cargado bajo demanda ya no existe en el
// servidor (pasa si la pestaña quedó abierta de una versión anterior de la app).
const ERROR_DE_VERSION =
  /dynamically imported module|Importing a module script failed|ChunkLoadError|Unable to preload CSS/i;

function clasificar(e: unknown): ErrorExportacion {
  const detalle = e instanceof Error ? e.message : String(e);
  return { tipo: ERROR_DE_VERSION.test(detalle) ? 'version' : 'otro', detalle };
}

/**
 * Estado de una exportación (Excel/PDF): cuál está en curso y, si falla, el error. Antes una
 * falla era silenciosa; ahora la pantalla puede avisar qué pasó.
 */
export function useExportacion() {
  const [exportando, setExportando] = useState<'xlsx' | 'pdf' | null>(null);
  const [error, setError] = useState<ErrorExportacion | null>(null);

  const ejecutar = useCallback(async (formato: 'xlsx' | 'pdf', tarea: () => Promise<void>) => {
    setExportando(formato);
    setError(null);
    try {
      await tarea();
    } catch (e) {
      console.error(`Error al exportar a ${formato}`, e);
      setError(clasificar(e));
    } finally {
      setExportando(null);
    }
  }, []);

  return { exportando, error, ejecutar, limpiarError: () => setError(null) };
}
